var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavouriteGameIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0482 3.62797C13.6593 4.24146 14.0024 5.07208 14.0024 5.93797C14.0024 6.80386 13.6593 7.63448 13.0482 8.24797L8.00154 13.3346L2.95487 8.24797C2.50103 7.79107 2.19205 7.21044 2.06661 6.57879C1.94116 5.94713 2.00483 5.2925 2.24964 4.69685C2.49444 4.1012 2.90951 3.591 3.44289 3.23011C3.97626 2.86922 4.60424 2.67368 5.2482 2.66797C6.1093 2.67319 6.9335 3.01821 7.54154 3.62797C7.71888 3.80345 7.87342 4.00056 8.00154 4.21464C8.12965 4.00056 8.2842 3.80345 8.46154 3.62797C8.76112 3.32401 9.11815 3.08263 9.51185 2.91788C9.90556 2.75313 10.3281 2.66828 10.7549 2.66828C11.1817 2.66828 11.6042 2.75313 11.9979 2.91788C12.3916 3.08263 12.7486 3.32401 13.0482 3.62797Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteGameIconSvg);
export default __webpack_public_path__ + "static/media/favouriteGame-icon-svg.14e4fa513761252a9ccb4658c08ad2c5.svg";
export { ForwardRef as ReactComponent };